import React from 'react';
// import ReactDOM from 'react-dom';
import {render} from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './scripts/App';
import registerServiceWorker from './registerServiceWorker';
import DataActions          from './scripts/flux/actions/DataActions.js';



// ReactDOM.render((
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   ), document.getElementById('root'));
// registerServiceWorker();


class AppInitializer {

    run() {
        DataActions.getPages((response)=>{
          render((
              <BrowserRouter>
                <App response={response} />
              </BrowserRouter>
            ), document.getElementById('root'));
            registerServiceWorker();
        });
    }
}

new AppInitializer().run();



// WEBPACK FOOTER //
// ./src/index.js